import { render, staticRenderFns } from "./AdminModal.vue?vue&type=template&id=4a0040a1&scoped=true"
import script from "./AdminModal.vue?vue&type=script&lang=js"
export * from "./AdminModal.vue?vue&type=script&lang=js"
import style0 from "./AdminModal.vue?vue&type=style&index=0&id=4a0040a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0040a1",
  null
  
)

export default component.exports